import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function HookSection() {
  const ref = useScrollReveal();
  return <section ref={ref} className="w-full section-padding" style={{
    backgroundColor: '#faf7f2'
  }} aria-label="Opening hook" data-id="element-163">
      <div className="max-w-2xl mx-auto text-center" data-id="element-164">
        {/* Time stamp */}
        <div className="scroll-reveal mb-8" data-id="element-165">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase px-3 py-1.5 rounded-full" style={{
          color: '#c9a96e',
          backgroundColor: 'rgba(201,169,110,0.1)',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-166">
            Sound Familiar?
          </span>
        </div>

        {/* Pull quote */}
        <div className="scroll-reveal scroll-reveal-delay-1 mb-8" data-id="element-167">
          <blockquote className="text-2xl md:text-3xl lg:text-4xl italic leading-snug" style={{
          fontFamily: "'Playfair Display', serif",
          color: '#1a2744'
        }} data-id="element-168">
            "It's 2:14 AM. You're standing in the hallway, staring at the closed
            door, physically vibrating with exhaustion."
          </blockquote>
        </div>

        <div className="scroll-reveal scroll-reveal-delay-2 gold-divider mb-8" data-id="element-169" />

        {/* Body copy */}
        <div className="scroll-reveal scroll-reveal-delay-3 space-y-5 text-left" data-id="element-170">
          <p className="text-base md:text-lg leading-relaxed" style={{
          color: '#4a4540',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-171">
            You have two choices: go in and begin a 90-minute negotiation that
            ends with them in your bed — or listen to them cry until your heart
            breaks.
          </p>
          <p className="text-base md:text-lg leading-relaxed" style={{
          color: '#4a4540',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-172">
            Most parents think these are the only two options.
          </p>
          <p className="text-xl md:text-2xl font-bold leading-snug" style={{
          fontFamily: "'Playfair Display', serif",
          color: '#1a2744'
        }} data-id="element-173">
            They aren't.
          </p>
          <p className="text-base md:text-lg leading-relaxed" style={{
          color: '#4a4540',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-174">
            Your toddler isn't "bad at sleeping" — their biological clock is
            simply <em data-id="element-175">unmoored.</em>
          </p>
        </div>
      </div>
    </section>;
}